import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M49.844 4.707a4.21 4.21 0 0 0-3.52 2.16L.537 89.04c-1.565 2.808.471 6.259 3.686 6.256h91.552c3.215.003 5.251-3.448 3.686-6.256L53.677 6.866a4.21 4.21 0 0 0-3.833-2.159m.165 17.032c3.416 0 6.183 1.018 6.182 4.435v39.774c0 3.416-2.766 4.153-6.182 4.152s-6.189-.736-6.188-4.152V26.174c0-3.417 2.772-4.435 6.188-4.435m0 52.845c4.066.003 7.356 3.3 7.36 7.366a7.37 7.37 0 0 1-7.36 7.378 7.373 7.373 0 0 1 0-14.744" />
  </svg>
);
const ForwardRef = forwardRef(SvgWarning);
export default ForwardRef;
